import type useRelatedProducts from "@/viewModels/product-detail/features/useRelatedProducts";
import ProductsSlider from "@/components/features/products/productsSlider/ProductsSlider";
import BadgeButton from "@/components/ui/BadgeButton";

const RelatedProductSlider = ({
  relatedProducts,
  isRelatedProductsLoading,
  relatedCategory,
  relatedAttrAndTerm,
  relatedFilter,
  filteredRelatedProducts,
  updateRelatedFilter,
}: ReturnType<typeof useRelatedProducts>) => {
  return (
    <section className="brand-container">
      <h3 className="brand-heading-md mt-3 text-left text-base-content lg:mt-6">相關商品</h3>
      <div className="mb-3 mt-3 flex gap-2">
        {/* Category Filter*/}
        {relatedCategory && (
          <BadgeButton
            label={relatedCategory.name}
            isActive={relatedFilter.categoryId === relatedCategory.id}
            onClick={() => updateRelatedFilter({ categoryId: relatedCategory.id })}
          />
        )}

        {/* Roast Term Filter*/}
        {relatedAttrAndTerm && (
          <BadgeButton
            label={relatedAttrAndTerm.term.name}
            isActive={relatedFilter.attribute?.termId === relatedAttrAndTerm.term.id}
            onClick={() =>
              updateRelatedFilter({
                attribute: {
                  attrId: relatedAttrAndTerm.attr.id,
                  termId: relatedAttrAndTerm.term.id,
                },
              })
            }
          />
        )}
      </div>

      <ProductsSlider
        products={
          (relatedFilter && Object.keys(relatedFilter).length > 0 && filteredRelatedProducts) ||
          relatedProducts ||
          []
        }
        isLoading={isRelatedProductsLoading}
      />
    </section>
  );
};

export default RelatedProductSlider;
